import { replaceTranslationPlaceholders } from "../assets/js/theme/common/utils/translations-utils.js";
/**
 * Get redeemable at display name from different
 * internal values i.e. online, in-store, all.
 */
export function getProductRedeemableAtDisplayText(redeemable_at) {
  const productRedeemableAtDisplayNames = {
    online: window.translations.online_text, // "Online",
    "in-store": window.translations.in_store_text, // "In-Store",
    all: window.translations.in_store_and_online_text, // "In store and Online",
  };
  return productRedeemableAtDisplayNames[redeemable_at];
}

/**
 * Get product expiry display text from internal expiry info
 * in months for different expiry types i.e. from-last-use, from-last-balance-check,
 * from-issue-date, indefinite, do-not-show
 */
export function getProductExpiryDisplayText(months, expiry_type) {
  if (expiry_type === "from-last-balance-check") {
    return replaceTranslationPlaceholders(
      window.translations.expiry_from_last_balance_check_text,
      { months: months }
    );
  }
  if (expiry_type === "from-issue-date") {
    return replaceTranslationPlaceholders(
      window.translations.expiry_from_issue_date_text,
      { months: months }
    );
  }
  if (expiry_type === "indefinite") {
    return window.translations.expiry_indefinite_text;
  }
  if (expiry_type === "do-not-show") {
    return window.translations.not_applicable_text;
  }
  if (expiry_type === "from-last-use") {
    return replaceTranslationPlaceholders(
      window.translations.expiry_since_last_used_text,
      { months: months }
    );
  }
  return window.translations.not_applicable_text;
}
